import { forwardRef, type Ref, type SVGProps } from "react";
const IconExpandFilledSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path d="m19.41 1.54 9.83-.1a1.13 1.13 0 0 1 .79.35 1.08 1.08 0 0 1 .34.78l-.1 9.87a1.07 1.07 0 0 1-1.06 1.06 1 1 0 0 1-1.05-1.05L28.24 5l-8.81 8.84A1 1 0 1 1 18 12.4l8.83-8.82-7.45.08a1 1 0 0 1-1.05-1.05 1.08 1.08 0 0 1 1.08-1.07m-5.75 27.85a1 1 0 0 0-1.05-1.05l-7.45.08L14 19.6a1 1 0 1 0-1.42-1.42L3.76 27l.08-7.47a1 1 0 0 0-1-1.05 1.07 1.07 0 0 0-1.06 1.06l-.1 9.87a1.08 1.08 0 0 0 .34.78 1.13 1.13 0 0 0 .79.35l9.83-.1a1.08 1.08 0 0 0 1.02-1.05" />
    <path d="M2.77 31.56a2.2 2.2 0 0 1-1.5-.64 2.1 2.1 0 0 1-.64-1.5l.1-9.87a2.08 2.08 0 0 1 2.05-2.05 2 2 0 0 1 2 2.05v5l7.08-7.1a2 2 0 0 1 2.82 0 2 2 0 0 1 .59 1.41 2 2 0 0 1-.59 1.42L7.6 27.4l5-.06a2 2 0 0 1 1.46.6 2 2 0 0 1 .6 1.46 2.08 2.08 0 0 1-2.06 2.06zm0-12a.05.05 0 0 0 0 .05l-.1 9.87c.09.11.1.11.19.12l9.76-.1a.09.09 0 0 0 .08-.08l-9.91.12v-2.46l.08-7.47zm15.94-4.41a2 2 0 0 1-1.41-.59 1.94 1.94 0 0 1-.59-1.4 2 2 0 0 1 .59-1.43l7.1-7.13-5 .06a2 2 0 0 1-2.06-2.06A2.09 2.09 0 0 1 19.4.54l9.83-.1a2.2 2.2 0 0 1 1.5.64 2.1 2.1 0 0 1 .64 1.5l-.1 9.86a2.08 2.08 0 0 1-2.05 2.06 2.05 2.05 0 0 1-1.44-.59 2 2 0 0 1-.59-1.47l.05-5-7.08 7.1a2 2 0 0 1-1.44.57zM29.26 2.57l-.1 9.89h.11l.1-9.86c-.09-.11-.1-.11-.19-.12l-9.76.1a.09.09 0 0 0-.08.08z" />
  </svg>
);
const ForwardRef = forwardRef(IconExpandFilledSVG);
ForwardRef.displayName = "IconExpandFilled";
export { ForwardRef as IconExpandFilled };
